import '@fontsource/poppins/latin.css';
import '@fontsource/inter/latin.css';
import { MantineProvider } from '@mantine/core';
import { NotificationsProvider } from '@mantine/notifications';
// eslint-disable-next-line
import { EnhancedStore } from '@reduxjs/toolkit';
import * as Sentry from '@sentry/react';
import { AnalyticsProvider } from 'use-analytics';
// eslint-disable-next-line
import { BrowserHistory } from 'history';
import React, { lazy, Suspense } from 'react';
import { Provider as ReduxProvider } from 'react-redux';
import { Navigate, Outlet, Route, Routes } from 'react-router-dom';
import { Global } from '@mantine/core';

import AppRoot from './components/core/AppRoot';
import AppShell from './components/core/AppShell';
import { PageSection } from './components/layouts';
import { LoaderWithOverlay } from './components/molecules';
import { ProtectedRoute } from './components/routes';
import { initAnalytics } from './lib/analytics';
import theme, { globalAppTheme } from './styles/theme/';
const analytics = initAnalytics();
import LandingPage from './pages/LandingPage';

const NotFoundPage = lazy(() => import('./pages/NotFoundPage'));
const OnboardingPage = lazy(() => import('./pages/account/OnboardingPage'));
const BrowseCandidatesPage = lazy(() => import('./pages/candidates/BrowseCandidatesPage'));
const CandidateDetailsPage = lazy(() => import('./pages/candidates/CandidateDetailsPage'));
const SharedShortlistPage = lazy(() => import('./pages/candidates/SharedShortlistPage'));

const ComingSoon = () => {
  return (
    <PageSection>
      <h1>Coming Soon</h1>
    </PageSection>
  );
};

/**
 *
 * @param {{history: BrowserHistory, store: EnhancedStore}} props
 */
export default function App({ history, store }) {
  return (
    <Sentry.ErrorBoundary showDialog={false}>
      <ReduxProvider store={store}>
        <MantineProvider theme={theme} withNormalizeCSS withGlobalStyles>
          <NotificationsProvider position="bottom-center">
            <AnalyticsProvider instance={analytics}>
              <AppRoot history={history}>
                <Global styles={globalAppTheme} />
                <Suspense fallback={<LoaderWithOverlay />}>
                  <Routes>
                    <Route path="/*" element={<Outlet />}>
                      {/* Public Routes */}
                      <Route index element={<LandingPage />} />
                      <Route path="auth" element={<LandingPage showAuthView />} />
                      <Route path="share/*" element={<Outlet />}>
                        <Route path="c/:candidateId" element={<CandidateDetailsPage />} />
                        <Route path="s/:sharedShortlistId" element={<SharedShortlistPage />} />
                      </Route>

                      {/* Protected Routes */}
                      <Route
                        path="*"
                        element={
                          <ProtectedRoute>
                            <AppShell />
                          </ProtectedRoute>
                        }
                      >
                        <Route path="candidates/*" element={<Outlet />}>
                          <Route index element={<Navigate to="browse/" replace />} />
                          <Route path="browse/" element={<BrowseCandidatesPage />} />
                          <Route path="shortlisted/" element={<BrowseCandidatesPage shortlistedOnly />} />
                          <Route path="*" element={<NotFoundPage />} />
                        </Route>
                        <Route path="account/*" element={<Outlet />}>
                          <Route index element={<ComingSoon />} />
                          <Route path="onboarding/" element={<OnboardingPage />} />
                          <Route path="profile/" element={<ComingSoon />} />
                          <Route path="company/" element={<ComingSoon />} />
                          <Route path="*" element={<NotFoundPage />} />
                        </Route>
                      </Route>
                    </Route>
                  </Routes>
                </Suspense>
              </AppRoot>
            </AnalyticsProvider>
          </NotificationsProvider>
        </MantineProvider>
      </ReduxProvider>
    </Sentry.ErrorBoundary>
  );
}
